















export default {
  name: "ProductList",
};
